import classNames from "classnames";
import { ReactDatePickerCustomHeaderProps } from "react-datepicker";
import { ReactComponent as ArrowIcon } from "@icons/arrow.svg";
import { getMonth, getYear } from "date-fns";
import { yearsBetweenDates } from "../helpers";
import { makeLocalizedListOfMonths } from "../../../core/locale";
import { Select } from "../../Select/Select";

const DateHeader = (edit: boolean = false, minDate?: Date, maxDate?: Date, selectedDate: Date = new Date()) => {
  if (!selectedDate || selectedDate === null) {
    selectedDate = new Date();
  }
  const editable = minDate && maxDate && selectedDate;
  const showEdit = editable && edit;
  const months = makeLocalizedListOfMonths("en-gb");

  return ({
    date,
    changeYear,
    changeMonth,
    decreaseMonth,
    increaseMonth,
    prevMonthButtonDisabled,
    nextMonthButtonDisabled,
  }: ReactDatePickerCustomHeaderProps) => (
    <div
      className={classNames(
        {
          "py-8": !showEdit,
          "py-10": showEdit,
        },
        "w-full flex justify-between h-12 items-center px-4 border-b border-brand-grey"
      )}
    >
      {!showEdit && (
        <button className="block shrink-0" aria-label="previous month" type="button" onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
          <ArrowIcon
            className={classNames("w-4 rotate-90", {
              prevMonthButtonDisabled,
              "opacity-50 cursor-not-allowed": prevMonthButtonDisabled,
            })}
          />
        </button>
      )}
      {showEdit ? (
        <div className="flex w-full gap-2 [&>*:first-child]:flex-[3] [&>*:last-child]:flex-[2]">
          <Select
            aria-label="month"
            value={months[getMonth(date)]}
            onChange={({ target: { value } }) => {
              changeMonth(months.indexOf(value));
            }}
          >
            {months.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </Select>
          <Select
            aria-label="year"
            value={getYear(date)}
            onChange={({ target: { value } }) => {
              changeYear(Number(value));
            }}
          >
            {yearsBetweenDates(minDate, maxDate, selectedDate).map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </Select>
        </div>
      ) : (
        <div className="flex">
          <h2 className="!p-0">
            {months[date.getMonth()]} {date.getFullYear()}
          </h2>
        </div>
      )}
      {!showEdit && (
        <button className="block shrink-0" aria-label="next month" type="button" onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
          <ArrowIcon
            className={classNames("w-4 -rotate-90", {
              "opacity-50 cursor-not-allowed": nextMonthButtonDisabled,
            })}
          />
        </button>
      )}
    </div>
  );
};

export default DateHeader;
